import { CONFIRM_EMAIL } from '../actions';

export const initialState = {
  error: null,
  success: false,
};

export const confirmEmail = (state = initialState, action) => {
  switch (action.type) {
    case CONFIRM_EMAIL._REQUEST: {
      state.error = null;
      return state;
    }
    case CONFIRM_EMAIL._ERROR: {
      state.error = action.error;
      return state;
    }
    case CONFIRM_EMAIL._SUCCESS: {
      state.success = action.success;
      return state;
    }
    default:
      return state;
  }
};
